import styled from '@emotion/styled';
import { fontFallback } from '@atlaskit/theme/typography';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ContainerButton = styled.button(props => ({
  display: 'inline-flex',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  width: 'auto',
  alignItems: 'center',
  padding: "var(--ds-space-025, 2px)",
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
  paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
  border: 'none',
  borderRadius: "var(--ds-border-radius, 3px)",
  color: props.colorsConfig.fontColor,
  background: props.colorsConfig.bgColor,
  cursor: 'pointer',
  outline: 0,
  transition: 'background 0.1s ease-out 0s',
  '&:focus-visible': {
    outline: `1px solid ${"var(--ds-border-focused, #388BFF)"}`,
    outlineOffset: "var(--ds-space-025, 2px)",
    background: props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorFocused
  },
  '&:hover': {
    background: props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorHovered
  },
  '&:active': {
    background: props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorPressed
  },
  '&:disabled': {
    cursor: 'default',
    color: props.disabledColorConfig.fontColor,
    background: props.disabledColorConfig.bgColor
  }
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ContainerSpan = styled.span(props => ({
  display: 'inline-flex',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  width: 'auto',
  alignItems: 'center',
  padding: "var(--ds-space-025, 2px)",
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
  paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
  borderRadius: "var(--ds-border-radius, 3px)",
  color: props.colorsConfig.fontColor,
  background: props.colorsConfig.bgColor,
  userSelect: 'none',
  '&.disabled': {
    color: props.disabledColorConfig.fontColor,
    background: props.disabledColorConfig.bgColor
  }
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const Name = styled.span({
  font: `var(--ds-font-body-small, ${fontFallback.body.small})`,
  fontWeight: "var(--ds-font-weight-medium, 500)",
  marginLeft: "var(--ds-space-025, 2px)",
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});